import React from 'react';
import './CitationTypesShareBarChart.scss';
import CustomTooltip from '../../../../shared/components/common/tooltip/CustomTooltip';
import EmptyPanel from '../../../../shared/components/empty-panel/EmptyPanel';
import { t } from 'i18next';
import StackedHorizontalBarChart, {
  StackedBarData,
} from '../../../../shared/components/chart/stacked-horizontal-bar-chart/StackedHorizontalBarChart';

interface CitationTypesShareBarChartProps {
  chartData: StackedBarData[];
}

const CitationTypesShareBarChart: React.FC<CitationTypesShareBarChartProps> = ({ chartData }) => {
  const hasData = chartData.length > 0;

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('citationTypes')}
          <CustomTooltip tooltipText="citationTypesTooltip" addMargin={false} />
        </div>
      </div>
      {!hasData ? (
        <div className="stats-box stats-box--bar-chart stats-box--empty">
          <div className="stats-box__content stats-box__content--empty">
            <EmptyPanel />
          </div>
        </div>
      ) : (
        <div className="stats-box stats-box--bar-chart citation-types-share-bar-chart">
          <div className="stats-box__content">
            <StackedHorizontalBarChart data={chartData} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CitationTypesShareBarChart;
